/**
 * Adds an arrow icon to the Buy now button (accelerated checkout button)
 */
(function() {
  'use strict';

  function addArrowToBuyNowButton() {
    // Find all accelerated checkout buttons in product forms
    const acceleratedCheckoutBlocks = document.querySelectorAll('.product-form-buttons shopify-accelerated-checkout');
    
    acceleratedCheckoutBlocks.forEach((block) => {
      // Wait for the button to be rendered
      const observer = new MutationObserver((mutations, obs) => {
        const button = block.querySelector('button');
        if (button && !button.dataset.arrowAdded) {
          // Check if arrow already exists
          const existingArrow = button.querySelector('.buy-now-arrow');
          if (!existingArrow) {
            // Create arrow element
            const arrow = document.createElement('span');
            arrow.className = 'buy-now-arrow';
            arrow.textContent = '→';
            arrow.style.cssText = 'margin-left: 0.5rem; color: #d3d3d3; font-size: 1.1em; display: inline-flex; align-items: center; line-height: 1;';
            
            // Try to append to button
            if (button.shadowRoot) {
              // If shadow DOM, try to inject into shadow root
              const shadowButton = button.shadowRoot.querySelector('button') || button.shadowRoot.firstElementChild;
              if (shadowButton) {
                shadowButton.appendChild(arrow);
              }
            } else {
              // Regular DOM
              button.appendChild(arrow);
            }
            
            button.dataset.arrowAdded = 'true';
          }
        }
      });

      // Start observing
      observer.observe(block, {
        childList: true,
        subtree: true
      });

      // Also try immediately in case button already exists
      const button = block.querySelector('button');
      if (button && !button.dataset.arrowAdded) {
        const arrow = document.createElement('span');
        arrow.className = 'buy-now-arrow';
        arrow.textContent = '→';
        arrow.style.cssText = 'margin-left: 0.5rem; color: #d3d3d3; font-size: 1.1em; display: inline-flex; align-items: center; line-height: 1;';
        
        if (button.shadowRoot) {
          const shadowButton = button.shadowRoot.querySelector('button') || button.shadowRoot.firstElementChild;
          if (shadowButton) {
            shadowButton.appendChild(arrow);
          }
        } else {
          button.appendChild(arrow);
        }
        
        button.dataset.arrowAdded = 'true';
      }
    });
  }

  // Run on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addArrowToBuyNowButton);
  } else {
    addArrowToBuyNowButton();
  }

  // Also run when new content is added (for dynamic product forms)
  const productFormObserver = new MutationObserver(() => {
    addArrowToBuyNowButton();
  });

  productFormObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
})();

